module.exports = __webpack_public_path__ + "img/story031.d0515843.webp";